import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../../../../../../../common/ExperimentContext/types';

export const PracticeCardExperimentVariant = {
  WithoutImage: 1,
  WithFirstImage: 2,
  WithLogo: 3,
};

export const PracticeCardExperiment = () =>
  makeExperimentWithData(
    'practice-card-tighter',
    createValidator<undefined | { variant: number }>(),
  );
